import script from "./HomeServiceListComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeServiceListComponent.vue?vue&type=script&setup=true&lang=js"

import "./HomeServiceListComponent.vue?vue&type=style&index=0&id=e85615dc&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e85615dc"]])

export default __exports__